const bars = (color: string, heights: number[]) =>
  heights.map((h, i) => (
    <div key={i} className="report-bar" style={{ height: h + '%', background: color + (Math.round((h / 100) * 200 + 55).toString(16)) }} />
  ));

export default function ReportsSection() {
  return (
    <section className="reports-section" id="reports">
      <div className="container">
        <div className="reports-header">
          <span className="section-label on-dark">Nově: Manažerské reporty</span>
          <h2>Nejen synchronizace.<br />Přehled, který vám řekne, jak na tom <span className="accent">doopravdy</span> jste.</h2>
          <p>Data proudí z vašich systémů do Money S3. Reporty se generují automaticky. Žádný Excel. Otevřete portál a víte.</p>
        </div>

        <div className="reports-grid">
          <div className="report-card">
            <div className="report-card-label">Tržby za měsíc</div>
            <div className="report-card-value purple">2,4 M Kč</div>
            <div className="report-card-trend up">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /></svg>
              +12.3% vs minulý měsíc
            </div>
            <div className="report-mini-chart">{bars('#A78BFA', [45,55,40,65,50,70,60,80,75,90,85,100])}</div>
          </div>

          <div className="report-card">
            <div className="report-card-label">Marže po prodejních kanálech</div>
            <div className="report-card-value gold">23.4 %</div>
            <div className="report-card-trend neutral">Shoptet 26% · WooCom 19% · Etsy 21%</div>
            <div className="report-mini-chart">{bars('#D4941A', [80,55,65,80,70,55,75,60,80,85,70,75])}</div>
          </div>

          <div className="report-card">
            <div className="report-card-label">Cash flow výhled</div>
            <div className="report-card-value green">+340 K Kč</div>
            <div className="report-card-trend up">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /></svg>
              Pozitivní trend tento kvartál
            </div>
            <div className="report-mini-chart">{bars('#4ADE80', [30,35,25,45,50,55,60,70,75,80,90,100])}</div>
          </div>
        </div>

        <div className="reports-features">
          <div className="reports-feature">
            <div className="reports-feature-icon">&#128202;</div>
            <div className="reports-feature-text"><h4>Data z reálných dokladů</h4><p>Reporty se generují z dat, která skutečně prošla synchronizací. Žádné ruční zadávání, žádné odhady.</p></div>
          </div>
          <div className="reports-feature">
            <div className="reports-feature-icon">&#9889;</div>
            <div className="reports-feature-text"><h4>Aktuální ke dnešnímu dni</h4><p>Nemusíte čekat na měsíční uzávěrku. Otevřete portál a máte čísla za včerejšek — nebo za poslední hodinu.</p></div>
          </div>
          <div className="reports-feature">
            <div className="reports-feature-icon">&#127919;</div>
            <div className="reports-feature-text"><h4>Pro majitele, ne pro účetní</h4><p>Tržby, marže, cash flow, prodejní kanály. Čísla, která potřebujete k rozhodování — ne k zaúčtování.</p></div>
          </div>
        </div>

        <div className="reports-cta">
          <a href="#cta" className="btn-primary btn-on-dark" style={{ fontSize: 16, padding: '16px 32px' }}>Chci vidět demo reportu</a>
        </div>
      </div>
    </section>
  );
}
